import type { JSX } from 'react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Input, Modal } from '@feathr/components';

interface ISaveCustomSetModalProps {
  opened: boolean;
  onClose: () => void;
  onSave?: (name: string) => Promise<void>;
  isSaving?: boolean;
}

function SaveCustomSetModal({
  opened: isModalOpen,
  onClose: closeModal,
  onSave,
  isSaving = false,
}: Readonly<ISaveCustomSetModalProps>): JSX.Element {
  const { t } = useTranslation();
  const [geofilterSetName, setGeofilterSetName] = useState('');

  const handleSave = async (): Promise<void> => {
    if (onSave && geofilterSetName.trim()) {
      await onSave(geofilterSetName.trim());
      setGeofilterSetName('');
    }
  };

  const handleClose = (): void => {
    setGeofilterSetName('');
    closeModal();
  };

  return (
    <Modal
      onClose={handleClose}
      opened={isModalOpen}
      rightActions={[
        <Button key={'cancel'} onClick={handleClose}>
          {t('Cancel')}
        </Button>,
        <Button isLoading={isSaving} key={'save'} onClick={handleSave} type={'primary'}>
          {t('Save')}
        </Button>,
      ]}
      size={'default'}
      title={t('Save custom set')}
    >
      <Input
        disabled={isSaving}
        label={t('Geofilter set name')}
        onChange={(newValue): void => setGeofilterSetName(newValue || '')}
        placeholder={t('Geofilter set name')}
        value={geofilterSetName}
      />
    </Modal>
  );
}

export default SaveCustomSetModal;
